window.initIssuesForm = function() {
  $.ajax({
    url: 'https://notifier.dev.bambooapp.eu/report-bug/new',
    data: {
      app_name: 	  "<%= Rails.application.class.module_parent.name %>",
      boom_env: 	  "<%= Rails.env %>",
      admin_name: 	"<%= current_admin.full_name %>",
      admin_email: 	"<%= current_admin.email %>",
      locale:       "<%= I18n.locale %>"
    },
    dataType: 'script'
  })
}